module.exports = __webpack_public_path__ + "fontawesome-webfont.db812d8a70a4e88e8887.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/fontawesome-webfont.woff2
// module id = ../../../../../src-admin/assets/fonts/fontawesome-webfont.woff2
// module chunks = styles